import React, { use, useEffect, useState } from "react";
import { Button, Grid, Typography } from "@mui/material";
// import TextField from "@/components/Form/TextField/TextField";
import SelectField from "../../SelectField/SelectField";
import AutoCompleteFeild from "../../MainWebsiteComponent/AutoCompleteFeild/AutoCompleteFeild";
import TextFieldCount from "../../MainWebsiteComponent/TextFieldCount/TextFieldCount";
// import AddressFeild from "../Form/AddressFeild/AddressFeild";
import CountrySelect from "../../MainWebsiteComponent/CountryField/CountryFeild";
import ZipCode from "../../MainWebsiteComponent/ZipCode/ZipCode";
import GooglePlaceField from "../../MainWebsiteComponent/GooglePlaceField/GooglePlaceField";
import { useDispatch, useSelector } from "react-redux";
//import actions
import * as actions from "../store/actions";
import {
  countryWithPhonelenght,
  validateZipCodeFormat,
} from "../../../hooks/HelperFunctions";

const organizationCategorisArray = [
  "Business",
  "Educational institution",
  "Religious Institution",
  "Research institution",
  "Social Services Organization",
  "Humanitarian Organization",
  "Government Agency",
  "Political Organization",
];

const AsAnOrganization = (props) => {
  const { loggedInUserInfo } = props;
  const dispatch = useDispatch();
  const [organizationName, setOrganizationName] = useState(
    useSelector((state) => state.organizationName)
  );
  const [country, setCountry] = useState(useSelector((state) => state.country));
  const [addressType, setAddressType] = useState(
    useSelector((state) => state.addressType)
  );
  const [zipCode, setZipCode] = useState(useSelector((state) => state.zipCode));
  const [state, setState] = useState(useSelector((state) => state.state));
  const [city, setCity] = useState(useSelector((state) => state.city));
  const [apt, setApt] = useState(useSelector((state) => state.apt));
  const [addressObj, setAddressObj] = useState(
    useSelector((state) => state.setAddressObj)
  );
  const [feilds, setFeilds] = useState(useSelector((state) => state.feilds));
  const [streetAddress, setStreetAddress] = useState(
    useSelector((state) => state.streetAddress)
  );
  const [dba, setDba] = useState(useSelector((state) => state.dba));
  const [organizationCategory, setOrganizationCategory] = useState(
    useSelector((state) => state.orgCategory)
  );
  let error = useSelector((state) => state.error);

  const StatehandleChanges = (event) => {
    setState(event.target.value);
    dispatch(actions.setState(event.target.value));
    const newErrors = { ...error };
    newErrors.state = false;
    dispatch(actions.setError(newErrors));
  };

  useEffect(() => {
    if (loggedInUserInfo) {
      dispatch(actions.setStreetAdress(loggedInUserInfo?.streetAddress));
      setStreetAddress(loggedInUserInfo?.streetAddress);

      dispatch(actions.setApt(loggedInUserInfo?.flOrSuiteNo));
      setApt(loggedInUserInfo?.flOrSuiteNo);

      dispatch(actions.setCity(loggedInUserInfo?.city));
      setCity(loggedInUserInfo?.city);

      dispatch(actions.setZipCode(loggedInUserInfo?.zipCode));
      setZipCode(loggedInUserInfo?.zipCode);

      dispatch(actions.setState(loggedInUserInfo?.state));
      setState(loggedInUserInfo?.state);

      let found = countryWithPhonelenght()?.find(
        (country) => country?.code == loggedInUserInfo?.country_short_name
      );
      dispatch(actions.setCountry(found));
      setCountry(found);
      // countryChnages(found)

      dispatch(
        actions.setAddressType(JSON.parse(loggedInUserInfo?.addressObj))
      );
      setAddressObj(JSON.parse(loggedInUserInfo?.addressObj));
      setAddressType(!loggedInUserInfo?.manualAddress);
    }
  }, [loggedInUserInfo]);

  const handleZipCodeChange = (newZipCode) => {
    setZipCode(newZipCode); // update the state of the parent component with the new zip code value
    console.log(zipCode);
    dispatch(actions.setZipCode(newZipCode));
  };

  const validateURL = (url) => {
    const regex = /^[a-zA-Z0-9-_ \s]{1,100}$/; // Allow letters, numbers, hyphen, underscore, and spaces, with length between 1 and 40
    return regex.test(url); // Returns true if the URL is valid, false otherwise
  };

  const handleChanges = (fieldName) => (event) => {
    const value = event.target.value;

    if (fieldName === "organizationName") {
      dispatch(actions.setOrgFullName(value));
      setOrganizationName(value);
    } else if (fieldName === "dba") {
      if (validateURL(value)) {
        dispatch(actions.setDba(value));
        dispatch(actions.setTeachingPageUrl(value));
        setDba(value);
      } else {
        setDba("");
        dispatch(actions.setDba(""));
        dispatch(actions.setTeachingPageUrl(""));
      }
    } else if (fieldName === "streetAddress") {
      dispatch(actions.setStreetAdress(value));
      setStreetAddress(value);
    } else if (fieldName === "apt") {
      dispatch(actions.setApt(value));
      setApt(value);
    } else if (fieldName === "city") {
      dispatch(actions.setCity(value));
      setCity(value);
    } else if (fieldName === "zipCode") {
      const isValid = validateZipCodeFormat(value);
      if (!isValid) {
        return false;
      }
      dispatch(actions.setZipCode(value));
      setZipCode(value);
    } else if (fieldName === "state") {
      dispatch(actions.setState(value));
      setState(value);
    } else if (fieldName === "country") {
      // dispatch( actions.setCountry(value) );
      // setCountry(value);
    }
    const newErrors = { ...error };
    newErrors[fieldName] = false;
    dispatch(actions.setError(newErrors));
  };

  const countryChnages = (data) => {
    if (data != undefined) {
      dispatch(actions.setCountry(data));
      setCountry(data);
    }
  };

  const fieldValue = (data) => {
    console.log("data coming from new com:", data);
    dispatch(actions.setOrgCategory(data));
    setOrganizationCategory(data);
    const newErrors = { ...error };
    newErrors.orgCategory = false;
    dispatch(actions.setError(newErrors));
  };

  //handleAddressChange
  const handleChangeWithData = (fieldName, fieldData) => {
    console.log(fieldData, "fieldData");
    dispatch(actions.setAddressType(fieldData));
    setAddressObj(fieldData);
    const newErrors = { ...error };
    newErrors.addressObj = false;
    dispatch(actions.setError(newErrors));
  };
  useEffect(() => {
    localStorage.setItem("addressType", false);
  }, []);

  const checkJsonStringOrNot = (address) => {
    if (typeof address === "string") {
      if (address.length == 0) {
        return "";
      }

      if (
        /^[\],:{}\s]*$/.test(
          address
            .replace(/\\["\\\/bfnrtu]/g, "@")
            .replace(
              /"[^"\\\n\r]*"|true|false|null|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?/g,
              "]"
            )
            .replace(/(?:^|:|,)(?:\s*\[)+/g, "")
        )
      ) {
        return JSON.parse(address);
      } else {
        return {};
      }
    } else {
      return address;
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextFieldCount
          label="Organization legal name"
          error={error.organizationName ? true : false}
          FieldErrorLabel={true}
          count="50"
          required
          value={organizationName}
          handleChange={handleChanges("organizationName")}
        />
      </Grid>
      <Grid item xs={12}>
        <TextFieldCount
          label="Teaching Account Name"
          TooltipStatus={true}
          TooltipText="DBA (Doing Business As) is an assumed, trade or fictitious name other than full legal name."
          error={error.dba ? true : false}
          FieldErrorLabel={true}
          required
          count="50"
          value={dba}
          handleChange={handleChanges("dba")}
        />
      </Grid>
      <Grid item xs={12}>
        <AutoCompleteFeild
          label="What category best describes your organization?"
          options={organizationCategorisArray}
          placeholder="Select category"
          required
          FieldErrorLabel={true}
          error={error.orgCategory ? true : false}
          // helperText={error.orgCategory ? "Please select category" : " "}
          fieldValue={fieldValue}
          // value={organizationCategory}
        />
      </Grid>

      {addressType ? (
        <>
          <Grid item xs={12}>
            <GooglePlaceField
              label="Address"
              validation={true}
              // handleChange={handleAddressChange}
              required
              placeholder="Your current resident address"
              // value={checkJsonStringOrNot(addressObj)}
              val={checkJsonStringOrNot(addressObj)}
              handleChange={(address) =>
                handleChangeWithData("addressObj", address)
              }
              error={error.addressObj ? true : false}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              sx={{
                marginTop: "10px !important",
                textTransform: "lowercase",
                fontWeight: "400 !important",
                textDecoration: "none !important",
                color: "#004FE0 !important",
              }}
              onClick={() => {
                localStorage.setItem("addressType", false);
                setAddressType(false);
              }}
            >
              <Typography
                sx={{
                  m: 0,
                  fontSize: "14px",
                  textTransform: "initial !important",
                  fontWeight: "400 !important",
                  color: "#004FE0",
                }}
              >
                Enter address manually
              </Typography>
            </Button>
          </Grid>
        </>
      ) : (
        <>
          <Grid item xs={12} md={12}>
            <div className="streetAddContainer">
              <TextFieldCount
                label="Street Address"
                // error={error.first_name ? "error" : ""}
                // validation={true}
                required
                error={error.streetAddress}
                FieldErrorLabel={true}
                // helperText={error.streetAddress ? "Street address" : " "}
                value={streetAddress}
                handleChange={handleChanges("streetAddress")}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldCount
              label="Apt/Floor"
              // error={error.first_name ? "error" : ""}
              // validation={true}
              value={apt}
              handleChange={handleChanges("apt")}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <div className="streetAddContainer">
              <TextFieldCount
                label="City/Town/Village"
                // error={error.first_name ? "error" : ""}
                // validation={true}
                error={error.city}
                FieldErrorLabel={true}
                // helperText={error.city ? "Please enter city" : " "}
                required
                value={city}
                handleChange={handleChanges("city")}
              />
            </div>
          </Grid>
          <Grid item xs={12} md={6}>
            <TextFieldCount
              label="State/Province/Territory"
              error={error.state}
              FieldErrorLabel={true}
              // helperText={error.city ? "Please enter city" : " "}
              required
              value={state}
              handleChange={handleChanges("state")}
            />
            {/* <SelectField
              label="State/Province/Territory"
              required
              options={states}
              validation
              selectedOption={state}
              handleChange={StatehandleChanges}
              error={error.state}
              FieldErrorLabel={true}
             
            /> */}
          </Grid>

          <Grid item xs={12} md={6}>
            <TextFieldCount
              label="Zip/Postal Code"
              // error={error.first_name ? "error" : ""}
              // validation={true}
              number="number"
              error={error.zipCode}
              FieldErrorLabel={true}
              // helperText={error.zipCode ? "Please enter zip code" : " "}
              required
              value={zipCode}
              handleChange={handleChanges("zipCode")}
            />
            {/* <ZipCode
              label="Zip/Postal Code"
              required
              onZipCodeChange={handleZipCodeChange}
              zipCode={zipCode}
              error={error.zipCode && zipCode?.length === 0}
              helperText={
                error.zipCode && zipCode?.length === 0 ? (
                  <span style={{ marginLeft: "-12px" }}>
                    Please enter zip code
                  </span>
                ) : (
                  " "
                )
              }
            /> */}
          </Grid>
          <Grid item xs={12}>
            <CountrySelect
              label="Countrys"
              placeholder="Select country"
              required
              validation={true}
              onSubmit={countryChnages}
              value={country}
            />

            <Button
              sx={{
                marginTop: "12px !important",
                textTransform: "lowercase",
                fontWeight: "400 !important",
                textDecoration: "none !important",
                color: "#004FE0 !important",
              }}
              onClick={() => {
                localStorage.setItem("addressType", true);
                setAddressType(true);
              }}
            >
              <Typography
                sx={{
                  m: 0,
                  fontSize: "14px",
                  textTransform: "uppercase !important",
                  fontWeight: "400 !important",
                  color: "#004FE0",
                }}
              >
                E
              </Typography>
              nter address in one line
            </Button>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default AsAnOrganization;

const organizationCategoris = [
  {
    label: "Educational institution",
    value: "Educational institution",
  },
  {
    label: "Islamic Center",
    value: "Islamic Center",
  },

  {
    label: "Mosque",
    value: "Mosque",
  },
  {
    label: "School",
    value: "School",
  },
];

const states = [
  { label: "Alabama", value: "Alabama" },
  { label: "Alaska", value: "Alaska" },
  { label: "Arizona", value: "Arizona" },
  { label: "Arkansas", value: "Arkansas" },
  { label: "California", value: "California" },
  { label: "Colorado", value: "Colorado" },
  { label: "Connecticut", value: "Connecticut" },
  { label: "Delaware", value: "Delaware" },
  { label: "Florida", value: "Florida" },
  { label: "Georgia", value: "Georgia" },
  { label: "Hawaii", value: "Hawaii" },
  { label: "Idaho", value: "Idaho" },
  { label: "Illinois", value: "Illinois" },
  { label: "Indiana", value: "Indiana" },
  { label: "Iowa", value: "Iowa" },
  { label: "Kansas", value: "Kansas" },
  { label: "Kentucky", value: "Kentucky" },
  { label: "Louisiana", value: "Louisiana" },
  { label: "Maine", value: "Maine" },
  { label: "Maryland", value: "Maryland" },
  { label: "Massachusetts", value: "Massachusetts" },
  { label: "Michigan", value: "Michigan" },
  { label: "Minnesota", value: "Minnesota" },
  { label: "Mississippi", value: "Mississippi" },
  { label: "Missouri", value: "Missouri" },
  { label: "Montana", value: "Montana" },
  { label: "Nebraska", value: "Nebraska" },
  { label: "Nevada", value: "Nevada" },
  { label: "New Hampshire", value: "New Hampshire" },
  { label: "New Jersey", value: "New Jersey" },
  { label: "New Mexico", value: "New Mexico" },
  { label: "New York", value: "New York" },
  { label: "North Carolina", value: "North Carolina" },
  { label: "North Dakota", value: "North Dakota" },
  { label: "Ohio", value: "Ohio" },
  { label: "Oklahoma", value: "Oklahoma" },
  { label: "Oregon", value: "Oregon" },
  { label: "Pennsylvania", value: "Pennsylvania" },
  { label: "Rhode Island", value: "Rhode Island" },
  { label: "South Carolina", value: "South Carolina" },
  { label: "South Dakota", value: "South Dakota" },
  { label: "Tennessee", value: "Tennessee" },
  { label: "Texas", value: "Texas" },
  { label: "Utah", value: "Utah" },
  { label: "Vermont", value: "Vermont" },
  { label: "Virginia", value: "Virginia" },
  { label: "Washington", value: "Washington" },
  { label: "West Virginia", value: "West Virginia" },
  { label: "Wisconsin", value: "Wisconsin" },
  { label: "Wyoming", value: "Wyoming" },
];

{
  /* <TextFieldCount
        label="Organization full name"
        // TooltipStatus={true}
        // TooltipText="hello"
        // validation={true}
        count="60"
        value={organizationName}
        handleChange={handleChanges()}
      />
      <br />
      <TextFieldCount
        label="Teaching Account Name"
        TooltipStatus={true}
        TooltipText="hello"
        // validation={true}
        count="60"
        value={organizationName}
        handleChange={handleChanges()}
      />
      <br />
      <br />
      <AutoCompleteFeild
        label="What category best describes your organization?"
        options={organizationCategorisArray}
        fieldValue={fieldValue}
      />
      <br />
      <TextField
        label="City"
        // TooltipStatus={true}
        // TooltipText="hello"
        // validation={true}
        count="60"
        value={organizationName}
        handleChange={handleChanges()}
      />
      <br />
      <TextField
        label="Zip Code"
        // TooltipStatus={true}
        // TooltipText="hello"
        // validation={true}
        count="60"
        value={organizationName}
        handleChange={handleChanges()}
      />
      <br />
      <AddressFeild/>
      <br /> <br /><br /> */
}
